module.exports = function() {
  return new Worker("/" + "babel-transpiler.0f21281d.worker.js");
};